import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { API_BASE_URL } from './constants';
import SkillTable from './components/Skills/SkillTable';
import LoadingScreen from './components/shared/LoadingScreen';
import SEO from './components/shared/SEO';

const Skills = () => {
    const { t } = useTranslation();
    const [skills, setSkills] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // --- INICIO REFACTOR: [FetchSkills Logic] COPIADO DESDE [components/Skills/SkillTable.js] ---
    const fetchSkills = useCallback(async () => {
        try {
            setLoading(true);
            const response = await fetch(`${API_BASE_URL}/skills`);

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }

            const data = await response.json();
            setSkills(data);
            setError(null);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, []); // Sin dependencia en `t` — evita recargar la página al cambiar idioma

    useEffect(() => {
        fetchSkills();
    }, [fetchSkills]);
    // --- FIN REFACTOR: [FetchSkills Logic] ---

    if (loading) {
        return <LoadingScreen />;
    }

    if (error) {
        return (
            <div className="min-h-screen bg-panel-gray flex items-center justify-center p-4">
                <div className="bg-red-50 border border-red-200 rounded-xl p-6 max-w-md">
                    <h3 className="text-red-800 font-bold text-lg mb-2">{t('SkillTable.error_title')}</h3>
                    <p className="text-red-600">{error}</p>
                    <button
                        onClick={fetchSkills}
                        className="mt-4 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
                    >
                        {t('SkillTable.retry')}
                    </button>
                </div>
            </div>
        );
    }

    return (
        <>
            <SEO title={t('MetaSkills.title')} description={t('MetaSkills.description')} />
            <SkillTable skills={skills} setSkills={setSkills} fetchSkills={fetchSkills} />
        </>
    );
};

export default Skills;
// Revisado: 2025-12-18 [I18n Scan]
